import React from 'react'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import KebabMenu from '../dataGrid/KebabMenu'
import TableData from '../atoms/table/TableData'
import StatusBtn from '../atoms/status/StatusBtn'
import CommonModal from '../atoms/modal/CommonModal'
import ProposalSummary from './modal/ProposalSummary'
import { ProposalPopup } from './modal/ProposalPopup'
import ButtonCustom from '../atoms/button/ButtonCustom'
import ProposalDetailModal from './modal/ProposalDetail'
import EditProposalModal from './modal/EditProposalModal'
import { openModal, setModalData } from '../../features/commonSlice'
import { sendReminder } from '../../features/proposalSlice'
import { formatCommonAmount } from '../../util/formatAmount'
import { statusData } from '../../util/constants'
import RateNowModal from './modal/RateNowModal'

export default function ReqSendTable({ rows }) {
	const navigate = useNavigate()
	const { kazooId } = useParams()
	const dispatch = useDispatch()
	const [menuRow, setMenuRow] = React.useState(null)
	const [menuAnchor, setMenuAnchor] = React.useState(null)
	const [editModalOpen, setEditModalOpen] = React.useState(false)
	const [summaryModalOpen, setSummaryModalOpen] = React.useState(false)
	const [proposalModalOpen, setProposalModalOpen] = React.useState(false)
	const [rateNowModalOpen, setRateNowModalOpen] = React.useState(false)
	const [selectedProposalData, setSelectedProposalData] = React.useState(null)
	const [popupStatus, setPopupStatus] = React.useState('')
	const [kazooData, setKazooData] = React.useState({})
	const handleProposalClick = (row, status, modalType) => {
		setKazooData(row)
		setPopupStatus(status)
		dispatch(openModal(modalType))
	}

	const columns = [
		{
			field: 'vendorName',
			headerName: 'Vendor',
			flex: 1,
			minWidth: 100,
			valueGetter: (value, params) => {
				return value || params.businessName || params.email
			},
		},
		{
			field: 'type',
			headerName: 'Type',
			flex: 1,
			minWidth: 100,
			valueGetter: (value) => {
				return value || 'invited'
			},
		},
		{
			field: 'budget',
			headerName: 'Budget',
			flex: 1,
			minWidth: 100,
			renderCell: (params) =>
				params?.value ? formatCommonAmount(params?.value) : '--',
		},
		{
			field: 'bidAmount',
			headerName: 'Vendor\u2019s Bid',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => {
				const amount = params?.value || params.row.bidAmount
				const budget =
					params.row.status !== 'New' ? params.row.budget : ''
				return amount
					? formatCommonAmount(amount)
					: budget
						? formatCommonAmount(budget)
						: '--'
			},
		},
		{
			field: 'status',
			headerName: 'Status',
			flex: 1,
			minWidth: 200,
			renderCell: (params) => {
				const status = statusData?.find(
					(item) => item.status === params.value
				)

				return (
					<StatusBtn
						size="small"
						label={status?.label || params.value}
						variant={status?.variant || 'default'}
					/>
				)
			},
		},
		{
			field: 'action',
			headerName: 'Action',
			flex: 0,
			minWidth: 350,
			headerClassName: 'header-column-right',
			sortable: false,
			filterable: false,
			align: 'right',
			renderCell: (params) => {
				return (
					<div
						style={{
							display: 'flex',
							gap: '8px',
							alignItems: 'center',
							height: '100%',
						}}
					>
						{params.row.paymentStatus === 'paid' && (
							<ButtonCustom
								variant="outlined"
								size="sm"
								onClick={(e) => {
									e.stopPropagation()
									handleRateNowClick(params.row)
								}}
							>
								<img
									src="/images/star-bordered.svg"
									alt="star-bordered.svg"
								/>
								Rate Now
							</ButtonCustom>
						)}
						{params.row.status === 'Submitted' && (
							<Box sx={{ display: 'flex', gap: '8px' }}>
								<ButtonCustom
									variant="destructive"
									size="sm"
									onClick={(e) => {
										e.stopPropagation()
										handleProposalClick(
											params.row,
											'Declined',
											'rejectProposal'
										)
									}}
								>
									Reject
								</ButtonCustom>
								<ButtonCustom
									variant="approve"
									size="sm"
									onClick={(e) => {
										e.stopPropagation()
										handleProposalClick(
											params.row,
											'Approved',
											'approveProposal'
										)
									}}
								>
									Approve
								</ButtonCustom>
							</Box>
						)}

						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'flex-end',
								height: '100%',
							}}
						>
							<ButtonCustom
								variant="outlined"
								size="sm"
								data-cy="kebab"
								onClick={(e) => openMenu(e, params.row)}
							>
								<img src="/images/more-horizontal.svg" alt="" />
							</ButtonCustom>
						</Box>
					</div>
				)
			},
		},
	]

	const openMenu = (e, row) => {
		e.stopPropagation()
		setMenuAnchor(e.currentTarget)
		setMenuRow(row)
	}

	const closeMenu = () => {
		setMenuAnchor(null)
		setMenuRow(null)
	}

	const handleClose = () => {
		setSummaryModalOpen(false)
		setSelectedProposalData(null)
	}
	const handleViewDetails = (row) => {
		if (!row) return
		setSelectedProposalData(row)
		if (row.status === 'New') setSummaryModalOpen(true)
		else setProposalModalOpen(true)
	}
	const handleRowClick = ({ row }) => {
		handleViewDetails(row)
	}
	const handleProposalClose = () => {
		setProposalModalOpen(false)
		setSelectedProposalData(null)
	}
	const approveProposal = (menuRow) => {
		dispatch(openModal('approveProposal'))
		handleProposalClick(menuRow, 'Approved', 'approveProposal')
		dispatch(setModalData(menuRow?.id))
		closeMenu()
	}
	const rejectProposal = (menuRow) => {
		dispatch(openModal('rejectProposal'))
		handleProposalClick(menuRow, 'Declined', 'rejectProposal')
		dispatch(setModalData(menuRow?.id))
		closeMenu()
	}
	const cancelRevisionRequest = (menuRow) => {
		handleProposalClose()
		dispatch(openModal('cancelRevisionRequest'))
		handleProposalClick(menuRow, 'Declined', 'cancelRevisionRequest')
		dispatch(setModalData(menuRow?.id))
		closeMenu()
	}
	const editRevisionRequest = (menuRow) => {
		handleProposalClose()
		dispatch(openModal('editRevisionRequest'))
		handleProposalClick(menuRow, 'Revision', 'editRevisionRequest')
		dispatch(setModalData(menuRow?.id))
		closeMenu()
	}
	const deleteProposal = (menuRow) => {
		handleProposalClose()
		dispatch(openModal('deleteProposal'))
		handleProposalClick(menuRow, 'Declined', 'deleteProposal')
		dispatch(setModalData(menuRow?.id))
		closeMenu()
	}

	const handleRateNowClick = (row) => {
		setSelectedProposalData(row)
		setRateNowModalOpen(true)
	}
	const handleRateNowClose = () => {
		setRateNowModalOpen(false)
		setSelectedProposalData(null)
	}

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						rows={rows}
						columns={columns}
						height="75dvh"
						checkboxSelection={false}
						onRowClick={handleRowClick}
						sx={{
							'& .MuiDataGrid-row': { cursor: 'pointer' },
						}}
					/>
				</Box>
				<KebabMenu
					anchorEl={menuAnchor}
					open={Boolean(menuAnchor)}
					onClose={closeMenu}
					index={
						['Submitted', 'Declined', 'Rejected'].includes(
							menuRow?.status
						)
							? 2
							: ['Approved', 'New', 'Revision'].includes(
										menuRow?.status
								  )
								? -1
								: 1
					}
					items={[
						{
							key: 'view_profile',
							label: 'View Vendor Profile',
							icon: (
								<img
									src="/images/buliding.svg"
									alt="view_profile"
								/>
							),
							onClick: () =>
								navigate(`/profile/${menuRow?.vendorId}`),
						},
						{
							key: 'view_details',
							label: 'View Details',
							icon: (
								<img
									src="/images/eye-open-icon.svg"
									alt="view_profile"
								/>
							),
							onClick: () => {
								handleViewDetails(menuRow)
								closeMenu()
							},
						},
						...(['Deleted'].includes(menuRow?.status)
							? []
							: [
									{
										key: 'chat_now',
										label: 'Chat Now',
										icon: (
											<img
												src="/images/chat-icon.svg"
												alt="chat_now"
											/>
										),
										onClick: () =>
											navigate(
												kazooId
													? `/wedding/chat/${kazooId}`
													: `/chat`,
												{
													state: {
														selectedUser: {
															_id: menuRow.vendorId,
															businessName:
																menuRow.vendorName,
															email: menuRow.email,
														},
													},
												}
											),
									},
								]),
						...(menuRow?.status === 'New'
							? [
									{
										key: 'edit_proposal',
										label: 'Edit Proposal',
										icon: (
											<img
												src="/images/edit-icon.svg"
												alt="view_profile"
											/>
										),
										onClick: () => {
											setSelectedProposalData({
												...menuRow,
												kid: Math.random(),
											})
											setEditModalOpen(true)
											closeMenu()
										},
									},
									{
										key: 'send_reminder',
										label: 'Send Reminder',
										icon: (
											<img
												src="/images/notification-blue.svg"
												alt="view_profile"
											/>
										),
										onClick: () =>
											dispatch(
												sendReminder({
													vendorId: menuRow?.vendorId,
													message:
														'You have been invited to submit a proposal for the wedding of ' +
														menuRow?.kazooName,
													type: 'Proposals',
													link: `/vendor-proposal`,
												})
											),
									},
									{
										key: 'cancel_request',
										label: (
											<p style={{ color: '#ff9b21' }}>
												Cancel Request
											</p>
										),
										icon: (
											<img
												src="/images/close-circle-yellow.svg"
												alt="Cancel Request"
											/>
										),
										onClick: () => {
											handleProposalClick(
												menuRow,
												'Declined',
												'cancelProposal'
											)
											dispatch(setModalData(menuRow?.id))
											closeMenu()
										},
										color: 'error.main',
									},
								]
							: []),
						...(menuRow?.status === 'Revision'
							? [
									{
										key: 'cancel_request',
										label: (
											<p style={{ color: '#ff9b21' }}>
												Cancel Revision Request
											</p>
										),
										icon: (
											<img
												src="/images/close-circle-yellow.svg"
												alt="Cancel Revision Request"
											/>
										),
										onClick: () =>
											cancelRevisionRequest(menuRow),
										color: 'error.main',
									},
								]
							: []),
						...(menuRow?.status === 'Submitted'
							? [
									{
										key: 'request_revision',
										label: (
											<p
												style={{
													color: 'var(--brand)',
												}}
											>
												Request Revision
											</p>
										),
										icon: (
											<img
												src="/images/refresh.svg"
												alt="view_profile"
											/>
										),
										onClick: () => {
											setKazooData(menuRow)
											dispatch(
												openModal('revisionProposal')
											)
											closeMenu()
										},
									},
									{
										key: 'approve_bid',
										label: (
											<p style={{ color: '#4CAF50' }}>
												Approve Bid
											</p>
										),
										icon: (
											<img
												src="/images/tick-circle.svg"
												alt="view_profile"
											/>
										),
										onClick: () => approveProposal(menuRow),
									},
									{
										key: 'reject_bid',
										label: (
											<p style={{ color: '#F44336' }}>
												Reject Bid
											</p>
										),
										icon: (
											<img
												src="/images/close-circle.svg"
												alt="view_profile"
											/>
										),
										onClick: () => rejectProposal(menuRow),
									},
								]
							: []),
						...(['Rejected', 'Declined']?.includes(menuRow?.status)
							? [
									{
										key: 'remove_from_list',
										label: (
											<p style={{ color: '#F44336' }}>
												Remove From List
											</p>
										),
										icon: (
											<img
												src="/images/close-circle.svg"
												alt="view_profile"
											/>
										),
										onClick: () => deleteProposal(menuRow),
									},
								]
							: []),
					]}
				/>
			</Box>

			<CommonModal
				open={summaryModalOpen}
				handleClose={handleClose}
				heading="Proposal Details"
				subHeading=""
				footerContent={
					<>
						<ButtonCustom
							onClick={handleClose}
							variant="outlined"
							size="lg"
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={() => {
								handleClose()
								setEditModalOpen(true)
								setSelectedProposalData({
									...selectedProposalData,
									kid: Math.random(),
								})
							}}
						>
							Edit
						</ButtonCustom>
					</>
				}
			>
				{summaryModalOpen && (
					<ProposalSummary
						selectedKazoo={selectedProposalData}
						setSelectedKazoo={setSelectedProposalData}
						selectedPackage={{
							...selectedProposalData?.packageDetails,
							addOnsIds:
								selectedProposalData?.packageDetails?.addOns,
							selectedAddOns:
								selectedProposalData?.packageDetails?.addOns?.map(
									(a) => a._id
								) ?? [],
						}}
					/>
				)}
			</CommonModal>

			<CommonModal
				open={proposalModalOpen}
				handleClose={handleProposalClose}
				heading={`Proposal from ${selectedProposalData?.vendorName ?? ''}`}
				page="planner-payments"
				subHeading={
					[
						selectedProposalData?.businessTypes?.join(', '),
						selectedProposalData?.customBusinessType,
					]
						.filter(Boolean)
						.join(', ') || ''
				}
				Chip={
					selectedProposalData?.status === 'Approved' ? (
						<StatusBtn label="Bid Approved" variant="approved" />
					) : selectedProposalData?.status === 'Revision' ? (
						<StatusBtn
							label="Revision Requested"
							variant="revision"
						/>
					) : ['Rejected', 'Declined']?.includes(
							selectedProposalData?.status
					  ) ? (
						<StatusBtn label="Bid Rejected" variant="error" />
					) : (
						''
					)
				}
				footerContent={
					<>
						{selectedProposalData?.status === 'Submitted' && (
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									width: '64%',
								}}
							>
								<div>
									<ButtonCustom
										onClick={() => {
											handleProposalClose()
											setKazooData(selectedProposalData)
											dispatch(
												openModal('revisionProposal')
											)
										}}
										variant="default"
										size="lg"
									>
										Request Revision
									</ButtonCustom>
								</div>
							</div>
						)}
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: '10px',
							}}
						>
							{selectedProposalData?.status === 'Submitted' && (
								<>
									<ButtonCustom
										size="lg"
										variant="destructive"
										onClick={() => {
											handleProposalClose()
											rejectProposal(selectedProposalData)
										}}
									>
										Reject Bid
									</ButtonCustom>
									<ButtonCustom
										size="lg"
										variant="approve"
										onClick={() => {
											handleProposalClose()
											approveProposal(
												selectedProposalData
											)
										}}
									>
										Approve Bid
									</ButtonCustom>
								</>
							)}
							{selectedProposalData?.status === 'Revision' && (
								<>
									<ButtonCustom
										onClick={() =>
											editRevisionRequest(
												selectedProposalData
											)
										}
										variant="link"
										size="lg"
									>
										Edit Revision
									</ButtonCustom>
									<ButtonCustom
										size="lg"
										variant="destructive"
										onClick={() =>
											cancelRevisionRequest(
												selectedProposalData
											)
										}
									>
										Cancel Revision Request
									</ButtonCustom>
								</>
							)}
						</div>
					</>
				}
			>
				<ProposalDetailModal proposalData={selectedProposalData} />
			</CommonModal>

			<EditProposalModal
				open={editModalOpen}
				selectedKazoo={selectedProposalData}
				setSelectedKazoo={setSelectedProposalData}
				handleClose={() => {
					setEditModalOpen(false)
					setSelectedProposalData(null)
				}}
			/>
			<ProposalPopup kazooData={kazooData} status={popupStatus} />

			<RateNowModal
				data={selectedProposalData}
				isOpen={rateNowModalOpen}
				handleClose={handleRateNowClose}
			/>
		</div>
	)
}
